module.exports = __webpack_public_path__ + "assets/word_data_default.3b732143.svg";